import React, { useState } from 'react';
import { IProperty } from '../utils/JsonApiRequest';
import PropertyRequest from '../utils/PropertyRequest';
import ButtonRound from './ButtonRound';
import { createToast } from './MaterialUi/Toast';
import styles from './PropertyPublishBox.scss';
import LogError from '../utils/LogError';

export interface IPropertyPublishBoxProps {
    id: IProperty['drupal_internal__id'];
}

const PropertyPublishBox: React.FC<React.PropsWithChildren<IPropertyPublishBoxProps>> = ({ id = null }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [wasPublished, setWasPublished] = useState(false);
    const [currModerationState, setCurrModerationState] = useState<IProperty['moderation_state']>(null);

    const publishProperty = (moderation_state: IProperty['moderation_state']) => {
        setCurrModerationState(moderation_state);
        setIsLoading(true);
        PropertyRequest.publish(id, moderation_state)
            .then(() => {
                setIsLoading(false);
                createToast('Erfolgreich Veröffentlicht.', 'success');
                setWasPublished(true);
            })
            .catch((e) => {
                setIsLoading(false);
                console.error(e);
                createToast('Fehler beim Veröffentlichen', 'error');
                LogError.add(e, {
                    title: 'Fehler beim Veröffentlichen',
                    error_code: 'PropertyPublishBox.tsx:publishProperty',
                    request_data: { id, moderation_state }
                });
            });
    };

    return (
        <div className={styles.propertyPublishBox + (wasPublished ? ` ${styles.wasPublished}` : '')}>
            <h2>Vorschau</h2>
            <p>Hier siehst Du eine Vorschau Deiner Immobilie. Bist Du zufrieden mit der Ansicht? Dann kannst Du die Immobilie hier exklusiv veröffentlichen:</p>
            <ButtonRound
                isLoading={currModerationState === 'exclusively_published' && isLoading}
                onClick={() => {
                    publishProperty('exclusively_published');
                }}
            >
                Jetzt exklusiv veröffentlichen und Anfragen bekommen
            </ButtonRound>
            <p>
                Natürlich kannst Du auch auf die Vorteile des exklusiven Uploads verzichten und Deine Immobilie auch{' '}
                <ButtonRound
                    type="submit"
                    variant="link"
                    isLoading={currModerationState === 'published' && isLoading}
                    onClick={() => {
                        publishProperty('published');
                    }}
                >
                    regulär veröffentlichen
                </ButtonRound>{' '}
                und auf anderen Plattformen hochladen.
            </p>

            <p>Du möchtest Deine Angaben korrigieren? Dann gehe zum Bearbeiten.</p>
            <ButtonRound variant="outlined" href={`/property/${id}/edit`}>
                Weiter bearbeiten
            </ButtonRound>
        </div>
    );
};

export default PropertyPublishBox;
